export default __webpack_public_path__ + "static/media/phone.9a95eed1.svg";